import { allContractorSubscriptionPlanOptions, contractorStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import ContractorCompanyName from "components/table/columnComponents/ContractorCompanyName"
import ContractorInstalledDevicesCount from "components/table/columnComponents/ContractorInstalledDevicesCount"
import { ContractorStatus } from "components/table/columnComponents/ContractorStatus"
import ContractorWarrantyDevicesCount from "components/table/columnComponents/ContractorWarrantyDevicesCount"

export const getContractorTableHeaderCells = (
  contractorAccountStatusOptions: UITypes.Option[],
): UITypes.TableHeaderCell[] => [
  {
    title: "Company name",
    type: "sort-search",
    name: "name",
    cellComponent: ContractorCompanyName,
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
  },
  {
    title: "Brand Name",
    type: "sort-search",
    name: "brand",
  },
  {
    title: "Contractor Status",
    type: "color-select",
    name: "account_status_id",
    options: contractorAccountStatusOptions,
    cellComponent: ContractorStatus,
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
  },
  {
    title: "Creation Date",
    type: "sort-date-range",
    name: "create_date",
  },
  {
    title: "Subscription Plan",
    type: "select",
    name: "subscription_plan",
    options: allContractorSubscriptionPlanOptions,
  },
  {
    title: "Purchased Devices",
    type: "sort-search",
    name: "purchased",
  },
  {
    title: "Installed Devices",
    type: "sort-search",
    name: "installed",
    cellComponent: ContractorInstalledDevicesCount,
  },
  {
    title: "Installed Last 7 days",
    type: "sort",
    name: "install_7_day",
  },
  {
    title: "Activated mobile apps",
    type: "sort",
    name: "active_mobile",
  },
  {
    title: "Inventory",
    type: "sort-search",
    name: "inventory",
  },
  {
    title: "Warranty",
    type: "sort-search",
    name: "warranty",
    cellComponent: ContractorWarrantyDevicesCount,
  },
  {
    title: "Account Status",
    type: "select",
    name: "isEnabled",
    options: contractorStatusOptions,
    cellComponent: "boolean",
  },
]
